import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import DeleteIcon from "react-icons/lib/fa/times-circle-o";
import MenuIcon from "react-icons/lib/fa/ellipsis-h";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import ConfirmModal from "../components/ConfirmModal";
import { toast } from "react-toastify";

import { updateOffer, setPage } from "../offers/actions";

import colors from "../colors";

class RowActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  deleteOffer = () => {
    const { item, updateOffer, setPage } = this.props;

    updateOffer({ isDeleted: true }, item.get("uid")).then(() => {
      toast.success("Oferta została usunięta!");
      setPage({ page: 1 });
    });

    this.toggle();
  };

  render() {
    const { isOpen } = this.state;
    const { item } = this.props;
    return (
      <div>
        <ConfirmModal
          message={`Czy na pewno chcesz usunąć ofertę "${item.get(
            "title"
          )}" ? Operacja jest nieodwracalna.`}
          isOpen={isOpen}
          onCancel={this.toggle}
          onConfirm={this.deleteOffer}
        />
        <UncontrolledDropdown onClick={e => e.stopPropagation()}>
          <StyledDropdownToggle tag="div">
            <MenuIcon size="15" />
          </StyledDropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={this.toggle}>
              <DeleteIcon size="15" />
              <ItemText>Usuń ofertę</ItemText>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    );
  }
}

const StyledDropdownToggle = styled(DropdownToggle)`
  padding: 12px 20px;
  &:hover {
    color: ${colors.secondary};
  }
`;

const ItemText = styled.span`
  font-size: 14px;
  margin-left: 10px;
`;

RowActions = connect(null, { updateOffer, setPage })(RowActions);
export default RowActions;



// WEBPACK FOOTER //
// ./src/offers/RowActions.js